export default __webpack_public_path__ + "static/media/5704.057ba23a.jpg";